import { Button, Classes, Intent, Popover, Position, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import ApplyChanges from "./ApplyChanges";
import { EditorConfig } from "./EditorConfigForm";
import { Controls } from "./styled/fragments";
import SystemInfoButtons from "./SystemInfoButtons";

export interface IEditControls {
	barOpen: boolean;
	toggleBar: () => void;
	popupOpen: boolean;
	togglePopup: () => void;
	config: EditorConfig;
	onConfigChange: (config: EditorConfig) => void;
}

const EditControls: React.SFC<IEditControls> = ({barOpen, toggleBar, popupOpen, togglePopup, config, onConfigChange}) => (
	<Controls editActive={barOpen} className={Classes.DARK}>

		<div style={{display: "flex", alignItems: "center"}}>
			<SystemInfoButtons />
		</div>

		<ApplyChanges />

		<div>
			<Tooltip content={(barOpen ? "Hide" :  "Show") + " editing interface (Ctrl + E)"} position={Position.BOTTOM} usePortal={false}>
				<Button intent={Intent.PRIMARY} minimal={true} icon={barOpen ? IconNames.COLLAPSE_ALL : IconNames.NEW_TEXT_BOX} onClick={toggleBar} />
			</Tooltip>

			<Tooltip content={(popupOpen ? "Hide" :  "Show") + " editing window (Ctrl + W)"} position={Position.BOTTOM} usePortal={false}>
				<Button minimal={true} icon={popupOpen ? IconNames.CROSS : IconNames.COG} onClick={togglePopup} />
			</Tooltip>

			{/*<GlobalSettingsForm config={config} onChange={onConfigChange} useDialog={true} />*/}

			{/*<Popover content={<EditorConfigForm config={config} onChange={onConfigChange}/>} usePortal={false}>
				<Button icon={IconNames.COG} minimal={true} />
			</Popover>*/}
		</div>

	</Controls>
);

export default EditControls;



// WEBPACK FOOTER //
// ./src/core/components/editor/EditControls.tsx